import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { RecordSettingsPage } from '~/features/approvals/record-settings-page';

/** A record's settings that save on their own: Approvals (Step 11.5 of docs/plans/ledger.md; board A1). */
function SettingsRoute(): ReactElement {
  const { recordId } = Route.useParams();
  return <RecordSettingsPage recordId={recordId} />;
}

export const Route = createFileRoute('/_app/records/$recordId/settings')({ component: SettingsRoute });
